__webpack_require__.p = "/handheld-classification/";